import styled from 'styled-components';

export const TableContainer = styled.div`
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;

export const MessageBosx = styled.div`
  display: none;
  position: fixed;
  bottom: 20px;
  position: relative;
  margin: 10px;
  background-color: #f44336;
  color: white;
  padding: 5px 15px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1000;
`;

export const CloseButton = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Th = styled.th`
  text-align: left;
  font-weight: bold;
  color: black;
  text-decoration: underline;
`;

export const Td = styled.td`
  text-align: left;
  padding: 2px;
`;

export const GreenText = styled.span`
  color: #10b981; /* This is the hex value for Tailwind's text-green-500 */
`;

export const NavbarContainer = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  position: relative;
`;

export const NavbarTitle = styled.h1`
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0;
  flex: 1;
  text-align: center;
`;

export const NotificationButton = styled.button`
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  color: #333;

  &:hover:not(:disabled) {
    background-color: #f3f4f6;
    transform: scale(1.05);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    color: #9ca3af;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const NotificationBadge = styled.span<{ count: number }>`
  position: absolute;
  top: -2px;
  right: -2px;
  background-color: #ef4444;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 11px;
  font-weight: bold;
  display: ${(props) => (props.count > 0 ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  min-width: 18px;
`;

export const NavbarSpacer = styled.div`
  width: 40px; /* Same width as notification button to center the title */
`;
